import styled from 'styled-components';
import { useState, useEffect } from 'react';
import useStore, { actions } from '../../store/useStore';
import { RunButton } from '../Button';
import RadioGroup from '../Input/RadioGroup';
import NumberInput, { Unit } from '../Input/NumberInput';
import Checkbox from '../Input/Checkbox';
import Alert from '../Alert';
import { fertilizerTypes } from '../../services/fertilizer';
import ListOrder from '../Input/ListOrder';
import { guestKey } from '../../services/constants';

const DefaultComponent = styled.div``;

const RunModelBtn = styled(RunButton)`
    /* width: auto; */
    /* letter-spacing: inherit; */
    margin-bottom: 16px;
`;

const InputLabel = styled.label`
    display: inline-block;
    box-sizing: border-box;
    width: 120px;
    margin-right: 16px;
`;

const Settings = styled.div`
    margin-bottom: 8px;
    font-size: 0.9rem;
`;

const SettingsFertilizers = ({
    component = DefaultComponent,
    runModel,
    runBalanceAcidBase,
    busy,
    alertText,
    hasOutput,
}) => {
    const [localState, setLocalState] = useState({
        fertilizerSettings: {},
        inSync: false,
    });
    const { store, dispatch } = useStore();
    const {
        input: { fertilizerSettings },
        modelOutputElecCorrect,
        modelOutput,
        showElecCorrect,
    } = store;

    useEffect(() => {
        setLocalState((prev) => {
            return {
                ...prev,
                fertilizerSettings: store.input.fertilizerSettings,
                inSync: true,
            };
        });
    }, [store.input.fertilizerSettings]);

    const Container = component;

    const getHandleChangeFertilizerSetting = (key) => (nextValue) => {
        setLocalState((prev) => {
            return {
                ...prev,
                fertilizerSettings: {
                    ...prev.fertilizerSettings,
                    [key]: nextValue,
                },
                inSync: false,
            };
        });
    };

    const handleRunModel = () => {
        const recipe =
            showElecCorrect && modelOutputElecCorrect
                ? modelOutputElecCorrect
                : modelOutput.advies;
        runModel(localState.fertilizerSettings, recipe);

        dispatch(actions.setFertilizerSettings(localState.fertilizerSettings));
    };

    const handleBalanceAcidBase = () => {
        runBalanceAcidBase(store.modelOutputFertilizer);
    };

    let fertilzerOptions = [
        { label: 'vloeibaar', value: fertilizerTypes.liquid },
        { label: 'vast', value: fertilizerTypes.solid },
    ];
    if (store.key && store.key !== guestKey) {
        fertilzerOptions.push({
            label: 'vast met vloeibaar calcium',
            value: fertilizerTypes.solidWithLiquidCalcium,
        });
    }

    return (
        <Container>
            <Settings>
                <RadioGroup
                    label="Type meststof"
                    options={fertilzerOptions}
                    value={localState.fertilizerSettings.fertilizerType}
                    onChange={getHandleChangeFertilizerSetting(
                        'fertilizerType'
                    )}
                />
                {[
                    fertilizerTypes.solid,
                    fertilizerTypes.solidWithLiquidCalcium,
                ].includes(localState.fertilizerSettings.fertilizerType) && (
                    <div>
                        <InputLabel>Tankgrootte:</InputLabel>
                        <NumberInput
                            width={50}
                            value={localState.fertilizerSettings.tankSize}
                            onChange={getHandleChangeFertilizerSetting(
                                'tankSize'
                            )}
                        />
                        <Unit>
                            m<sup>3</sup>
                        </Unit>
                        <InputLabel>Concentratiefactor:</InputLabel>
                        <NumberInput
                            width={50}
                            value={
                                localState.fertilizerSettings.concentrateFactor
                            }
                            onChange={getHandleChangeFertilizerSetting(
                                'concentrateFactor'
                            )}
                        />
                        {/* <InputLabel>Gebruik ab-tanks:</InputLabel>
                        <Checkbox
                            style={{ display: 'inline' }}
                            value={fertilizerSettings.abTanks}
                            onChange={getHandleChangeFertilizerSetting(
                                'abTanks'
                            )}
                        /> */}
                    </div>
                )}
                <ListOrder
                    label="prioriteit"
                    helpText="Sleep de items naar de juiste plek om de volgorde aan te passen."
                    list={localState.fertilizerSettings.priority}
                    setList={getHandleChangeFertilizerSetting('priority')}
                />
            </Settings>

            {hasOutput && localState.inSync ? (
                <RunModelBtn
                    disabled={busy}
                    busy={busy}
                    onClick={handleBalanceAcidBase}
                >
                    Zuur en loog in balans brengen
                </RunModelBtn>
            ) : (
                <RunModelBtn
                    disabled={busy}
                    busy={busy}
                    onClick={handleRunModel}
                >
                    Start model
                </RunModelBtn>
            )}

            {alertText && <Alert>{alertText}</Alert>}
        </Container>
    );
};

export default SettingsFertilizers;
